import { motion } from 'motion/react';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer
      className="snap-section relative h-screen snap-center flex items-center justify-center px-6"
      style={{ backgroundColor: 'var(--butter)' }}
    >
      <div className="section-content w-full max-w-3xl mx-auto text-center flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h3
            className="text-editorial-names text-4xl md:text-5xl mb-6"
            style={{ fontFamily: 'var(--font-script)', color: 'var(--emerald)' }}
          >
            Samy <span style={{ color: 'var(--chartreuse)' }}>&</span> Dany
          </h3>
          <p
            className="text-editorial-meta text-sm md:text-base mb-10"
            style={{ letterSpacing: '0.2em' }}
          >
            27 | 06 | 2026
          </p>

 {/*  
          <div className="flex justify-center gap-4 mb-10">
            <motion.a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="w-12 h-12 rounded-full flex items-center justify-center border transition-colors hover:bg-[var(--pale-lime)]/50"
              style={{ borderColor: 'var(--chartreuse)' }}
            >
              <Instagram className="w-5 h-5" style={{ color: 'var(--emerald)' }} />
            </motion.a>
            <motion.a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="w-12 h-12 rounded-full flex items-center justify-center border transition-colors hover:bg-[var(--pale-lime)]/50"
              style={{ borderColor: 'var(--chartreuse)' }}
            >
              <Facebook className="w-5 h-5" style={{ color: 'var(--emerald)' }} />
            </motion.a>
            <motion.a
              href="mailto:samidani@wedding.com"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="w-12 h-12 rounded-full flex items-center justify-center border transition-colors hover:bg-[var(--pale-lime)]/50"
              style={{ borderColor: 'var(--chartreuse)' }}
            >
              <Mail className="w-5 h-5" style={{ color: 'var(--emerald)' }} />
            </motion.a>
          </div>

          */}

          <div className="flex items-center justify-center gap-2 mb-6">
            <Heart className="w-5 h-5" style={{ color: 'var(--chartreuse)' }} />
            <p className="text-editorial-meta text-xs" style={{ opacity: 0.85 }}>
              Gracias por ser parte de nuestra historia
            </p>
          </div>

          <div className="w-full h-px mb-6" style={{ backgroundColor: 'rgba(186, 159, 56, 0.3)' }} />

          <p className="text-editorial-meta text-xs" style={{ opacity: 0.7 }}>
            © 2026 Diseñado con amor para nuestro día especial por Dany.
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
